export default __webpack_public_path__ + "static/contact-e4ce3e0d9c6143e01ccb1dcedaf591a0.png";